import $ from 'jquery';
import _ from 'lodash';
import {getWidth, onResize, onScroll} from "../utils/window";
// import init from "../init";

export default function cart() {
	const $cart = $('#cart');
	const $main = $cart.find('.cart-main');
	const $loading = $cart.find('.cart-loading');

	function updateCart(url, formData, isProduct = false) {
		$loading.show();

		$.ajax({
			type: 'POST',
			data: formData,
			dataType: 'json',
			url: url,
			success: function(response) {
				let cartUrl = window.location.origin + '/cart';

				$.get(cartUrl).done(function(data){
					$main.html(data);

					// init($main);
					cartInit();

					$loading.hide();
					updateCartMainHeight();

					if (isProduct) {
						$('.header_button.-type-shop').click();
					}

				});
			},
			error: function(response) {
				alert('An error has occurred.');
				$loading.hide();
			}
		});
	}

	function updateQuantity(val, input, form) {
		input.val(val);
		updateCart(form.data('action'), form.serialize());
	}

	function setupItemQuantity() {
		const items = $cart.find('.cart-main-item-qty');

		items.each(function () {
			const _this = $(this);
			const form = _this.find('> form'),
				input = _this.find('.cart-main-item-qty_val'),
				lower = _this.find('.cart-main-item-qty_lower'),
				higher = _this.find('.cart-main-item-qty_higher');

			let val = input.val();

			lower.click(_.debounce(function() {
				if (val > 1) {
					val--;
				}
				updateQuantity(val, input, form);
			}, 100));

			higher.click(_.debounce(function() {
				val++;
				updateQuantity(val, input, form);
			}, 100));
		});
	}

	function setupItemRemoval() {
		const items = $cart.find('.cart-main-item-remove');

		items.each(function () {
			const _this = $(this);
			const form = _this.find('> form'),
				button = _this.find('.cart-main-item-remove_button');

			form.on('submit', function(e){
				e.preventDefault();

				const _this = $(this);
				const data = _this.serialize();

				updateCart(form.data('action'), form.serialize());
			});
		});
	}

	function cartInit() {
		setupItemQuantity();
		setupItemRemoval();
	}

	function addToCart() {
		const $product = $('.product');
		const form = $product.find('.product-add-to-cart-form');

		if ($product.length && form.length) {
			form.on('submit', function(e) {
				e.preventDefault();

				let data = form.serialize();
				let url = form.data('action');

				updateCart(url, data, true);
			});
		}
	}

	function updateCartMainHeight() {
		const wrapper = $cart.find('.cart-wrapper'),
			header = $cart.find('.cart-header'),
			main = $cart.find('.cart-main'),
			items = main.find('.cart-main-items'),
			footer = $cart.find('.cart-footer'),
			padding = $cart.find('.cart-padding');

		let height = 0;
		height = (wrapper.height() - header.outerHeight() - parseInt(header.css('margin-bottom')) - footer.outerHeight());
		if (padding.length) {
			height -= padding.outerHeight();
		}

		items.css('height', height + 'px');
	}

	cartInit();
	addToCart();
	updateCartMainHeight();

	onResize(updateCartMainHeight);


	// if (getWidth() < 1080) {
	// 	let lastScrollTop = 0;
	// 	let wrapper = $cart.find('.cart-wrapper');
	//
	// 	onScroll(function() {
	// 		let st = $(this).scrollTop();
	// 		if (st > lastScrollTop){
	// 			if (wrapper.hasClass('-padding')) {
	// 				wrapper.removeClass('-padding');
	// 				updateCartMainHeight();
	// 			}
	// 		} else {
	// 			if (!wrapper.hasClass('-padding')) {
	// 				wrapper.addClass('-padding');
	// 				updateCartMainHeight();
	// 			}
	// 		}
	// 		lastScrollTop = st;
	// 	});
	// }
}



// WEBPACK FOOTER //
// ./source/scripts/sections/cart.js